import { render, staticRenderFns } from "./location-list.vue?vue&type=template&id=33ba1093&scoped=true"
import script from "./location-list.vue?vue&type=script&lang=js"
export * from "./location-list.vue?vue&type=script&lang=js"
import style0 from "./location-list.vue?vue&type=style&index=0&id=33ba1093&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ba1093",
  null
  
)

export default component.exports